import { render, staticRenderFns } from "./ComponentWait.vue?vue&type=template&id=5074d69c&scoped=true"
import script from "./ComponentWait.vue?vue&type=script&lang=js"
export * from "./ComponentWait.vue?vue&type=script&lang=js"
import style0 from "./ComponentWait.vue?vue&type=style&index=0&id=5074d69c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074d69c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5074d69c')) {
      api.createRecord('5074d69c', component.options)
    } else {
      api.reload('5074d69c', component.options)
    }
    module.hot.accept("./ComponentWait.vue?vue&type=template&id=5074d69c&scoped=true", function () {
      api.rerender('5074d69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/edit/ComponentWait.vue"
export default component.exports